import React, {Fragment, useEffect, useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import { LinearProgress, Link } from '@material-ui/core';
import { ApiBackend } from '../../../providers/apibackend';
import { Product } from '../../../model/Product';
import { B2bCompany } from '../../../model/B2bCompany';
import * as XLSX from 'xlsx';
import { ImportEntry } from '../../../model/ImportEntry';
import { ProductVariant } from '../../../model/ProductVariant';
import { Countries } from '../../../providers/countries';
import { isTodayOrAfter, isTodayOrBefore, vasaloppetMoment } from "../../../utilities/date";

class Props {
    close: () => void;
}



const ImportEntriesForm = ({close} : Props) => {

    const [step, setStep] = useState('loadfile' as 'loadfile'|'selectcolumns'|'confirm');
    const [loading, setLoading] = useState(false);
    const [columns, setColumns] = useState(null as string[]);
    const [columnVasaId, setColumnVasaId] = useState(null as string);
    const [columnFirstName, setColumnFirstName] = useState(null as string);
    const [columnBirthDate, setColumnBirthDate] = useState(null as string);
    const [columnFisCode, setColumnFisCode] = useState(null as string);
    const [columnLastName, setColumnLastName] = useState(null as string);
    const [columnClub, setColumnClub] = useState(null as string);
    const [columnTeam, setColumnTeam] = useState(null as string);
    const [columnSex, setColumnSex] = useState(null as string);
    const [columnEmail, setColumnEmail] = useState(null as string);
    const [columnCountry, setColumnCountry] = useState(null as string);
    const [columnNationality, setColumnNationality] = useState(null as string);
    const [columnAddress, setColumnAddress] = useState(null as string);
    const [columnPostalCode, setColumnPostalCode] = useState(null as string);
    const [columnCity, setColumnCity] = useState(null as string);
    const [columnPrePackingGroup, setColumnPrePackingGroup] = useState(null as string);
    const [columnPhone, setColumnPhone] = useState(null as string);
    const [columnStartGroup, setColumnStartGroup] = useState(null as string);
    const [products, setProducts] = useState(null as Product[]);
    const [fileType, setFileType] = useState('xlsx');
    const [entries, setEntries] = useState(null as ImportEntry[]);
    const [b2bCompanies, setB2bCompanies] = useState(null as B2bCompany[]);
    const [rawRows, setRawRows] = useState(null as string[][]);
    const [b2bCompany, setB2bCompany] = useState(null as B2bCompany);
    const [product, setProduct] = useState(null as Product);
    const [productVariant, setProductVariant] = useState(null as ProductVariant);
  
    useEffect(() => {
        let backend = new ApiBackend();
        Promise.all([backend.listProducts(), backend.listB2bCompanies({includeArchived:false, companyName: null, existsInExternalAccountingSystem:null})]).then((values: [Product[], B2bCompany[]]) => {
            let pr = values[0].filter(x=>x.type=="race");
            pr.sort((x,y) => {return x.name < y.name ? -1 : 1});
            setProducts(pr);
            setB2bCompanies(values[1]);
        });
    },[]);


    useEffect(() => {
        if (columns){
            trySetColumns();
        }
    },[columns]);

    const renderSelectColumns = () => {

        const selects = [{
            col: "Förnamn",
            get: columnFirstName,
            set: setColumnFirstName
        },
        {
            col: "Efternamn",
            get: columnLastName,
            set: setColumnLastName
        },
        {
            col: "Kön",
            get: columnSex,
            set: setColumnSex
        },
        {
            col: "FödelseDatum",
            get: columnBirthDate,
            set: setColumnBirthDate
        },
        {
            col: "Email",
            get: columnEmail,
            set: setColumnEmail
        },
        {
            col: "Adress",
            get: columnAddress,
            set: setColumnAddress
        },
        {
            col: "Postnummer",
            get: columnPostalCode,
            set: setColumnPostalCode
        },
        {
            col: "Ort",
            get: columnCity,
            set: setColumnCity
        },
         {
            col: "Land",
            get: columnCountry,
            set: setColumnCountry
        }, 
        {
            col: "Nationalitet",
            get: columnNationality,
            set: setColumnNationality
        },
        {
            col: "VasaId",
            get: columnVasaId,
            set: setColumnVasaId
        },
        {
            col: "FIS-kod",
            get: columnFisCode,
            set: setColumnFisCode
        },
         {
            col: "Förpackningsgrupp",
            get: columnPrePackingGroup,
            set: setColumnPrePackingGroup
        },
         {
            col: "Telefonnr",
            get: columnPhone,
            set: setColumnPhone
        },
         {
            col: "Startgrupp",
            get: columnStartGroup,
            set: setColumnStartGroup
        }
        ,
         {
            col: "Klubb",
            get: columnClub,
            set: setColumnClub
        }
         ,
         {
            col: "Team",
            get: columnTeam,
            set: setColumnTeam
        }
        ];

        const parseBirthDate =(val: number|string) : string =>
        {
            if (!val)
                return null;

            let w = val +'';
            if (w.indexOf("-") > 0 && w.length == 10)
            {
               return w;
            }

            if (w.length == 6)
            {
                let y = w.substring(0,2);
                let m = w.substring(2,4);
                let d = w.substring(4);
                return (+y < 20 ? "20" + y : "19"+y) + "-" + m + "-" + d;
            }
             if (w.length == 8 && w.indexOf("-") <= 0)
            {
                let y = w.substring(0,4);
                let m = w.substring(4,6);
                let d = w.substring(6);
                return y + "-" + m + "-" + d;
            }
            else if (w.length == 8 && w.indexOf("-") > 0)
            {
                let d = w.substring(0,2);
                let m = w.substring(3,5);
                let y = w.substring(7);
                return (+y < 20 ? "20" + y : "19"+y) + "-" + m + "-" + d;
            }
            return null; 

        }

        const getRowValueOrNull = (row: string[], column: string) => {
            if (!column)
                return null;

            let idx = columns.findIndex(x=>!!x && x.toLowerCase() == column.toLowerCase());
            if (idx < 0)
                return null;
            let val = row[idx];
            if (val)
            {
                val = val+"";
                val = val.trim();
            }
            return val;
        }

        return <Fragment>
                {selects.map((s) => {
                    return <>
                    <Grid item xs={6}>Kolumn för {s.col}</Grid>
                <Grid item xs={6}><Select native value={s.get} onChange={(ev) => {s.set(ev.target.value as string);}}>
                    <option value=""></option>
                    {columns.map((c) => {
                        if (!c)
                            return null;
                        return <option value={c}>{c}</option>
                    })}
                </Select></Grid>
                    </>
                })}
                <Grid item xs={12}>

                <Button variant="contained" onClick={() => {
                        setStep("loadfile");
                    }}>Tillbaka</Button>

                    <Button variant="contained" onClick={() => {

                         let rows = [] as ImportEntry[];
                         let abort = false;
                        for (let r = 0; r < rawRows.length; r++)
                        {
                            const row = rawRows[r];
                        
                            let e = {
                                firstName: getRowValueOrNull(row, columnFirstName),
                                lastName: getRowValueOrNull(row, columnLastName),
                                address: getRowValueOrNull(row,columnAddress),
                                birthDate: parseBirthDate(getRowValueOrNull(row,columnBirthDate)),
                                city: getRowValueOrNull(row, columnCity),
                                country: getRowValueOrNull(row, columnCountry),
                                email: getRowValueOrNull(row, columnEmail),
                                fisCode: getRowValueOrNull(row, columnFisCode),
                                nationality: getRowValueOrNull(row,columnNationality),
                                postCode: getRowValueOrNull(row,columnPostalCode),
                                vasaId: getRowValueOrNull(row, columnVasaId),
                                 sex: getRowValueOrNull(row,columnSex),
                                 prePackingGroup: getRowValueOrNull(row, columnPrePackingGroup),
                                 phoneNo: getRowValueOrNull(row,columnPhone),
                                 startGroupName : getRowValueOrNull(row,columnStartGroup),
                                 clubName: getRowValueOrNull(row, columnClub),
                                 team : getRowValueOrNull(row, columnTeam)
                                 

                            } as ImportEntry;

                            if (e.email)
                                e.email = e.email.toLowerCase();

                            if (!e.firstName || !e.lastName)
                                continue;

                            if (!e.birthDate)
                            {
                                 alert("Felaktigt födelsedatum för " + e.firstName + " " + e.lastName);
                                 abort=true;
                                 break;
                            }

                            const ccode = Countries.getCountryByAbbr(e.country);
                            if (!ccode)
                            {
                                const country = Countries.getCountryByName(e.country);
                                if (country)
                                {
                                    e.country = country.abbr;
                                }
                                else 
                                {
                                    console.log("Code: " + e.country + " is not OK for country");
                                    alert("Felaktigt land för " + e.firstName + " " + e.lastName);
                                    abort=true;
                                    break;
                                }
                            }
                            else 
                            {
                                e.country = ccode.abbr;
                            }
                            const natCode = Countries.getCountryByAbbr(e.nationality);
                            if (!natCode)
                            {
                                const nat = Countries.getCountryByName(e.nationality);
                                if (nat)
                                {
                                    e.nationality = nat.abbr;
                                }
                                else 
                                {
                                    console.log("Code: " + e.nationality + " is not OK for nationality");
                                    alert("Felaktigt nationalitet för " + e.firstName + " " + e.lastName);
                                    abort=true;
                                    break;
                                }
                            }
                            else 
                            {
                                e.nationality = natCode.abbr;
                            }

                            if (e.sex =="m")
                            {
                                e.sex ="M";
                            }
                            if (e.sex == "f" || e.sex == "w" || e.sex == "W")
                            {
                                e.sex = "F";
                            }
                            

                            if (e.sex != "M" && e.sex != "F")
                            {
                                alert("Felaktigt kön för " + e.firstName + " " + e.lastName + ", ska vara M/F");
                                abort = true;
                                break;
                            }
                           
                            rows.push(e);
                        };

                        if (abort)
                        {
                               setStep("loadfile");
                        }
                        else 
                        {
                        setEntries(rows);

                        let backend = new ApiBackend();
                        setLoading(true);
                        backend.prepareEntriesForImport(product.id,productVariant.Id, rows).then((e) => {
                            setEntries(e);
                            setLoading(false);
                        });

                        setStep("confirm");
                    }
                    }}>Nästa</Button>
                </Grid>
            </Fragment>

    }

    const renderConfirm = () => {

        return <Fragment>
                <Grid item xs={12}>Anmälningar att importera</Grid>
                        <Grid item xs={1}><b>VASA-ID</b></Grid>
                        <Grid item xs={2}><b>Namn i fil</b></Grid>
                        <Grid item xs={2}><b>Namn hos vasaloppet</b></Grid>
                        <Grid item xs={1}><b>Email</b></Grid>
                        <Grid item xs={1}><b>Kön</b></Grid>
                        <Grid item xs={1}><b>Födelsedatum</b></Grid>
                        <Grid item xs={1}><b>Startgrupp</b></Grid>
                        <Grid item xs={2}><b>Fel?</b></Grid>
                        <Grid item xs={1}></Grid>
                
                    {!loading && entries && entries.map((r,idx) => {
                        let bg = "";
                        if (r.error)
                        {
                            bg = "#FF0000";
                        }
                        else if (r.warn) {
                            bg = "#FFFF00";
                        }
                        else if (r.note)
                        {
                            bg = "#EEEEEE";
                        }
                        
                        return <>
                        <Grid style={{background: bg}} item xs={1}>{r.vasaId}</Grid>
                        <Grid style={{background: bg}} item xs={2}>{r.firstName} {r.lastName}</Grid>
                        <Grid style={{background: bg}} item xs={2}>{r.firstNameVasa} {r.lastNameVasa}</Grid>
                        <Grid style={{background: bg}} item xs={1}>{r.email}</Grid>
                        <Grid style={{background: bg}} item xs={1}>{r.sex}</Grid>
                        <Grid style={{background: bg}} item xs={1}>{r.birthDate}</Grid>
                        <Grid style={{background: bg}} item xs={1}>{r.startGroupName}</Grid>
                        <Grid style={{background: bg}} item xs={2}>{r.note}</Grid>
                        <Grid style={{background: bg}} item xs={1}><Link style={{textDecoration: 'underline', color:"#000000"}} onClick={() => {
                            entries.splice(idx,1);
                            setEntries([...entries]);
                        }}>Ta bort</Link></Grid>
                        </>
                    })}
                
                <Grid item xs={12}>
                    <Button variant="contained" onClick={() => {
                        setStep("selectcolumns");
                    }}>Tillbaka</Button>
                    <Button variant="contained" onClick={() => {
                         setLoading(true);
                         let back = new ApiBackend();
                         back.importEntries(b2bCompany.id, product.id, productVariant.Id, entries).then((resp)=> {
                            setLoading(false);
                            if (!resp)
                            {
                                alert("Kunde inte importera anmälningar, ett fel uppstod!");
                            }
                            else 
                            {                             
                                alert("Anmälningar har importerats!");
                                close();
                            }
                         });                       
                    }}>Importera</Button>
                </Grid>
            </Fragment>

    }
    const parseXLSX= (data : string) =>
{    
        let readedData = XLSX.read(data, {type: 'binary', cellDates:true, cellText: false});
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];

        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, {header:1, raw: false, dateNF: 'yyyy-mm-dd'}) as string[][];
        setColumns(dataParse[0]);
        setRawRows(dataParse.slice(1));
        setLoading(false);

        setStep('selectcolumns');
}

   
   
    const renderChooseFile = () => {
        return <>

            <Grid item xs={6}>
                Företag
            </Grid>
            <Grid item xs={6}>
                <Select native value={b2bCompany?.id} onChange={(ev) => {setB2bCompany(b2bCompanies.find(x=>x.id == ev.target.value))}}>
                    <option value=""></option>
                    {b2bCompanies && b2bCompanies.map(x=> {
                        return <option value={x.id}>{x.name}</option>
                    })}
                </Select>
            </Grid>

            <Grid item xs={6}>
                Produkt
            </Grid>
            <Grid item xs={6}>
                <Select native value={product?.id} onChange={(ev) => {setProduct(products.find(x=>x.id == ev.target.value))}}>
                    <option value=""></option>
                    {products && products.map(x=> {
                        return <option value={x.id}>{x.name}</option>
                    })}
                </Select>
            </Grid>

             <Grid item xs={6}>
                Produktvariant
            </Grid>
            <Grid item xs={6}>
                <Select native value={productVariant?.Id} onChange={(ev) => {setProductVariant(product.variants.find(x=>x.Id == ev.target.value))}}>
                    <option value=""></option>
                    {product && product?.variants?.map(x=> {
                        return <option value={x.Id}>{x.Name}</option>
                    })}
                </Select>
            </Grid>

             <Grid item xs={6}>
                Prisgrupp som kommer användas
            </Grid>
            <Grid item xs={6}>
                {product?.variants.find(x=>x.Id == productVariant?.Id)?.priceGroups.find(x=>x.isPublic && isTodayOrBefore(x.validFrom) && isTodayOrAfter(x.validTo))?.Name}
            </Grid>


             <Grid item xs={6}>
                Typ av fil
            </Grid>
            <Grid item xs={6}>
                <Select native value={fileType} onChange={(ev) => {setFileType(ev.target.value as string);}}>
                    <option value="xlsx">Excel</option>
                </Select>
            </Grid>

            <Grid item xs={6}>
                Välj fil
            </Grid>
            <Grid item xs={6}>
                        <input
            accept={fileType == "xlsx" ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" : "text/csv"}
            style={{ display: 'none' }}
            id="raised-button-file"
            type="file"
            onChange={(ev) => {
                setLoading(true);
                let file = ev.target.files[0];
                const reader = new FileReader();
                reader.addEventListener('load', (event) => {
                    if (fileType == "xlsx")
                    {
                        parseXLSX(event.target.result as string)
                    }
                    
                });
                if (fileType == "xlsx")
                {
                     reader.readAsBinaryString(file)
                }
                else 
                {
                    reader.readAsText(file);
                }
            }}
            />
            <label htmlFor="raised-button-file">
                <Button variant="contained" component="span">
                    Välj fil
                </Button>
            </label> 
            </Grid>
        </>;
    }

    const findCol = (names: string[]) =>{
        let name = null;
        for (let i = 0; i < names.length; i++)
        {
            let id = columns.findIndex(x=> !!x &&  x.toLowerCase() == names[i].toLowerCase());
            if (id >= 0)
            {
                
                name = columns[id];
                break;
            }
        }
        return name;
    }

    const trySetColumns = () => {
        setColumnVasaId(findCol(["vasaid","vasa-id"]));
        setColumnFirstName(findCol(["förnamn","fornavn","firstname","first name", "NAME"]));
        setColumnLastName(findCol(["efternamn","etternavn","lastname","familyname", "family name", "SURNAME"]));
        setColumnFisCode(findCol(["fiscode","fiskod", "FIS CODE"]));
        setColumnBirthDate(findCol(["birthdate","Date of birth if no Swedish person number YYMMDD","D.O.B"]));
        setColumnSex(findCol(["sex (m/f)","sex","GENDER"]));
        setColumnAddress(findCol(["address","adress"]));
        setColumnCountry(findCol(["country"]));
        setColumnNationality(findCol(["nationality (e.g. swe, nor)","nationality","NAT"]));
        setColumnPostalCode(findCol(["zip code"]));
        setColumnCity(findCol(["city"]));
        setColumnEmail(findCol(["email","e-mail"]));
        setColumnPhone(findCol(["phone","telephone","phoneno."]));
    }

    return <Fragment>
        <Grid container spacing={2}>
            {loading && <Grid item xs={12}>
                <LinearProgress color="secondary"/>
            </Grid>}
            {step == "loadfile" && renderChooseFile()}
            {step == "selectcolumns" && renderSelectColumns()}
            {step == "confirm" && renderConfirm()}
        </Grid>
    </Fragment>;

}
export default ImportEntriesForm;
